<template>
  <thead>
    <slot />
  </thead>
</template>
